import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import BubbleIcon from '@/assets/icons/BubbleIcon';
import { Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import IconButton from '@/components/Button/IconButton';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { getAlphaColor } from '@/styles/colors/color.utils';

type Props = {
  onCloseClick: () => void;
  onAIExploreClick: () => void;
  onCreateOwnClick: () => void;
};

const CreateTopicGuide = (props: Props) => {
  const color = useColor();
  return (
    <Style g={16} a="center" j="space-between">
      <Flex g={16} a="flex-start">
        <BubbleIcon fill={color.primary100} />
        <VFlex g={4}>
          <Typo type="label1" weight="m">
            Group your feedback into topics
          </Typo>
          <Typo type="body2" weight="r">
            Generate a topic using AI or create one yourself.
          </Typo>
        </VFlex>
      </Flex>
      <Flex j="flex-end" g={8} a="center">
        <Button variant="primary" sizeType="m" onClick={props.onAIExploreClick}>
          Explore with AI
        </Button>
        <Button
          variant="outlined"
          sizeType="m"
          onClick={props.onCreateOwnClick}
        >
          Create your own
        </Button>
        <IconButton
          icon={<CloseOutlined />}
          outlined={false}
          onClick={props.onCloseClick}
        />
      </Flex>
    </Style>
  );
};

const Style = styled(Flex)`
  background-color: ${(props) =>
    getAlphaColor(props.theme.colors.primary100, 0.04)};
  padding: 16px 24px;
  border-radius: ${(props) => props.theme.radius.card}px;
`;

export default CreateTopicGuide;
